<!--
 * @Descripttion: 
 * @Author: Yi Yunwan
 * @Date: 2021-03-10 11:28:58
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2021-06-17 17:25:33
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { isIOS } from './utils'
export default {
  created() {
    const isProd = false
    let url = ''
    if (isIOS) {
      url = isProd
        ? 'https://at.umtrack.com/49HHrm'
        : 'https://at.umtrack.com/1v81PD'
    } else {
      url = isProd
        ? 'https://at.umtrack.com/XDyGXn'
        : 'https://at.umtrack.com/CimmqC'
    }
    console.log('是否是ios：', isIOS)
    console.log('即将跳转：', url)
  }
}
</script>

<style lang="scss">
#app {
  @import '@/styles/index.scss';
  min-height: 100vh;
}
</style>
